import type { PaginationAtom } from '@/common/components/pagination/types.ts';
import { atom, type WritableAtom } from 'jotai';

type WithInitialValue<Value> = {
  init: Value;
};

export type Pagination = {
  page: number;
  perPage: number;
};

export const DEFAULT_PAGINATION: Pagination = {
  page: 1,
  perPage: 25,
};

export function createPaginationState(): [
  PaginationAtom,
  WritableAtom<null, [], void> & WithInitialValue<null>,
] {
  const paginationAtom = atom(DEFAULT_PAGINATION);

  const resetPaginationOnFilterChangeAtom = atom(null, (_get, set) => {
    set(paginationAtom, DEFAULT_PAGINATION);
  });

  return [paginationAtom, resetPaginationOnFilterChangeAtom];
}
